export default __webpack_public_path__ + "static/media/gallery-3-3.91ccb65c.webp";